import script from "./LilaBarriersHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./LilaBarriersHistory.vue?vue&type=script&setup=true&lang=js"

import "./LilaBarriersHistory.vue?vue&type=style&index=0&id=2255ff02&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2255ff02"]])

export default __exports__